// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"630":"fdf10e53","694":"8ba33376"}[chunkId] + ".css";
};